import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("rmb_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export { API };
export default api;

// Stripe Checkout / Billing Portal refuse to render inside an iframe (e.g. the
// Emergent preview). Break out to the top window so the hosted page loads.
export function externalRedirect(url) {
  const framed = window.top && window.top !== window.self;
  if (framed) {
    try {
      window.top.location.href = url;
      return;
    } catch (e) {
      window.open(url, "_blank", "noopener");
      return;
    }
  }
  window.location.href = url;
}
